export const toKebabCase = (text: string): string => {
  if (typeof text === 'string') {
    return text
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/[\s_]+/g, '-')
      .toLowerCase()
  } else {
    return ''
  }
}

export const toCamelCase = (value: string): string =>
  value.toLowerCase().replace(/[-_.\s]+([a-z0-9])/g, (_, c: string) => c.toUpperCase())

export const toNumberArray = (value: string): number[] => (value ? value.split(',').map((s) => parseInt(s)) : [])

export const toBool = (value?: string): boolean => {
  if (value === '1') {
    return true
  } else if (value === '0') {
    return false
  } else {
    return false
  }
}
